import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BRAND } from '@/content';

export default function Intro({ onDone }) {
  const [leaving, setLeaving] = useState(false);
  const reduced = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  useEffect(() => {
    if (reduced) {
      onDone();
      return;
    }
    const t = setTimeout(() => finish(), 2000);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const finish = () => {
    if (leaving) return;
    setLeaving(true);
    setTimeout(onDone, 450);
  };

  return (
    <AnimatePresence>
      {!leaving && (
        <motion.div
          data-testid="intro-overlay"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#FAF9F6]"
          exit={{ y: '-100%' }}
          transition={{ duration: 0.45, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="relative flex items-center justify-center">
            {/* circle + rails + train — fades out as the logo resolves */}
            <motion.svg
              width="220" height="220" viewBox="0 0 220 220" fill="none" aria-hidden="true"
              className="absolute"
              animate={{ opacity: [1, 1, 0], scale: [1, 1, 1.06] }}
              transition={{ duration: 2, times: [0, 0.68, 0.86] }}
            >
              <motion.circle
                cx="110" cy="110" r="72"
                stroke="#C92F4B" strokeWidth="5" strokeLinecap="round"
                strokeDasharray="452" strokeDashoffset="452"
                animate={{ strokeDashoffset: 0 }}
                transition={{ duration: 0.85, ease: 'easeInOut' }}
              />
              <motion.line x1="20" y1="150" x2="86" y2="132" stroke="#A7ABB0" strokeWidth="4" strokeLinecap="round"
                initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ delay: 0.5, duration: 0.45 }} />
              <motion.line x1="134" y1="132" x2="200" y2="150" stroke="#A7ABB0" strokeWidth="4" strokeLinecap="round"
                initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ delay: 0.55, duration: 0.45 }} />
              <motion.rect
                x="0" y="94" width="46" height="26" rx="9" fill="#A41225"
                initial={{ x: -60, opacity: 0 }}
                animate={{ x: 230, opacity: [0, 1, 1, 0] }}
                transition={{ delay: 0.8, duration: 0.8, ease: 'easeInOut' }}
              />
            </motion.svg>
            {/* official logo resolves out of the circle */}
            <motion.img
              src={BRAND.logo}
              alt="Codename Metro One Navade"
              className="relative w-52"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 1.35, duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>
          <button
            data-testid="intro-skip-btn"
            onClick={finish}
            className="absolute bottom-8 right-6 min-h-[44px] rounded-full border border-[#404145]/25 px-5 py-2.5 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-[#404145]"
          >
            Skip
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
